import { unsafeCSS, html, nothing } from "lit";
import { classMap } from "lit/directives/class-map.js";
import { e } from "../../scoped-registry-mixin-2fqf-E5n.js";
import { SlotController } from "../../utilities/slot.js";
import { LeafElement } from "../../components/leaf-element.js";
const styles = ":host {\n  display: block;\n}\n:host .chc-c-product-card__provider {\n  background-color: var(--leaf-color-bg-subtle);\n}\n:host .chc-c-product-card__provider-header {\n  display: flex;\n  justify-content: center;\n  padding: var(--leaf-spacing-24) var(--leaf-spacing-32);\n}\n:host .chc-c-product-card__provider-content {\n  padding: var(--leaf-spacing-24) var(--leaf-spacing-32);\n}";
const _CHCProductCardProvider = class _CHCProductCardProvider extends e(LeafElement) {
  constructor() {
    super(...arguments);
    this.slotController = new SlotController(this);
  }
  render() {
    const componentClassName = {
      "chc-c-product-card__provider": true
    };
    return html`<div class=${classMap(componentClassName)}>
      ${this.slotController.hasNamedSlot("covered") ? nothing : html` <div class="chc-c-product-card__provider-header">
            <slot></slot>
          </div>`}
      <slot name="covered"></slot>
    </div>`;
  }
};
_CHCProductCardProvider.styles = unsafeCSS(styles);
let CHCProductCardProvider = _CHCProductCardProvider;
export {
  CHCProductCardProvider
};
//# sourceMappingURL=product-card-provider.component.js.map
